var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import cx from 'classnames';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { Typography as MaterialTypography, } from '@material-ui/core';
var styles = function (theme) { return ({
    boldHeading: {
        fontWeight: theme.typography.fontWeightBold,
    },
    boldText: {
        fontWeight: theme.typography.fontWeightMedium,
    },
    underline: {
        textDecoration: 'underline',
    },
}); };
var useStyles = makeStyles(styles);
/** Типографический элемент */
export var Typography = function (props) {
    var _a;
    var bold = props.bold, underline = props.underline, variant = props.variant, other = __rest(props, ["bold", "underline", "variant"]);
    // Разделяем заголовки от обычного текста
    var isHeading = ['h1', 'h2', 'h3', 'h4'].some(function (el) { return el === variant; });
    var s = useStyles();
    return (React.createElement(MaterialTypography, __assign({}, other, { variant: variant, classes: {
            root: cx((_a = {},
                _a[s.boldHeading] = bold && isHeading,
                _a[s.boldText] = bold && !isHeading,
                _a[s.underline] = underline && !isHeading,
                _a)),
        } })));
};
Typography.defaultProps = {
    color: 'primary',
    bold: false,
    underline: false,
};
export default Typography;
//# sourceMappingURL=Typography.js.map